// extracted by mini-css-extract-plugin
module.exports = {"heroLinks":"hero_heroLinks__odtmb"};